import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineEnvelopeCheckIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16.29 8.71a1.001 1.001 0 0 0 .71.2958 1.0003 1.0003 0 0 0 .71-.2958l4-4a1.0041 1.0041 0 1 0-1.42-1.42L17 6.59l-1.29-1.3a1.003 1.003 0 0 0-.71-.294 1.0041 1.0041 0 0 0-.71 1.714l2 2ZM21 8a1 1 0 0 0-1 1v9a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1V8.41l5.88 5.89a2.9998 2.9998 0 0 0 2.11.87 3.08 3.08 0 0 0 2.16-.9l1.72-1.72a1.0041 1.0041 0 1 0-1.42-1.42l-1.75 1.75a1 1 0 0 1-1.4 0L5.41 7H11a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v10a2.9998 2.9998 0 0 0 3 3h14a3 3 0 0 0 3-3V9a1.0001 1.0001 0 0 0-1-1Z"/>
  </SvgIcon>
}

export default LineEnvelopeCheckIcon
